import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../Store/Store'

export interface ShippingRequest {
  id?: number,
  name: string,
  fix_price?: number,
  is_free?: boolean,
  note?: string,
  status?: string
}

export interface ShippingResponse {
  id: number,
  name: string,
  fix_price?: number,
  is_free: boolean,
  fee?: number,
  min_price?: number,
  max_price?: number,
  min_distance?: number,
  max_distance: number,
  whitelist?: string,
  blacklist?: string,
  note?: string,
  auto: boolean,
  service_token?: string,
  auto_service?: string,
  status: string,
  shop_id: number
}

export const shippingApi = createApi({
  reducerPath: 'shippingApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/shipping/panel',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['shipping'],

  endpoints: (builder) => ({
    getAllShippings: builder.query<ShippingResponse[], void>({
      query: () => 'all',
      providesTags: ['shipping']
    }),
    getShipping: builder.query<ShippingResponse, number>({
      query: (id) => `${id}`,
    }),
    createShipping: builder.mutation<boolean, ShippingRequest>({
      query: (data) => ({
        url: '',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['shipping']
    }),
    updateShipping: builder.mutation<ShippingResponse, Partial<ShippingRequest> & Pick<ShippingRequest, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['shipping']
    }),
    deleteShipping: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['shipping']
    }),
  }),
})

export const { useGetAllShippingsQuery, useGetShippingQuery, useCreateShippingMutation, useUpdateShippingMutation, useDeleteShippingMutation} = shippingApi